import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n';
import toast from './plugins/toastify';
import { dayjs } from './plugins/dayjs';
import primeVue from './plugins/primevue';
import JsonExcel from 'vue-json-excel3';
import vueGtag from 'vue-gtag';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(vuetify);
app.use(i18n);
app.use(primeVue);
app.use(vueGtag, {
    appName: 'KMITL1 SYSTEM',
    pageTrackerScreenviewEnabled: true,
    config: { id: 'G-39D9KEN2F3' }
}, router);

app.component("downloadExcel", JsonExcel);

app.config.globalProperties.$dayjs = dayjs;
app.config.globalProperties.$toast = toast;

store.dispatch('keycloak/initKeycloak');

app.mount('#app');